import { PermissionEnum } from '@api/enum';
import useAuthPermission from '@hooks/use-auth-permission';
import { NavPills } from '@hyperflake/react-ui-library';
import { PageHeading, PageTemplate } from 'modules/shared/features/content';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';

const AiWrongInformationLayout = () => {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const { hasPermission } = useAuthPermission();

    const navItems = [
        {
            content: 'AI People Flow',
            href: `/analytics/ai-wrong-information/ai-people-flow`,
            isActive: pathname.startsWith(`/analytics/ai-wrong-information/ai-people-flow`),
            permission: hasPermission(PermissionEnum.AI_WRONG_INFORMATION_READ),
        },
        {
            content: 'AI Safety Analysis',
            href: `/analytics/ai-wrong-information/ai-safety-analysis`,
            isActive: pathname.startsWith(`/analytics/ai-wrong-information/ai-safety-analysis`),
            permission: hasPermission(PermissionEnum.AI_WRONG_INFORMATION_READ),
        },
        {
            content: 'AI Equipment Tracking',
            href: `/analytics/ai-wrong-information/ai-equipment-tracking`,
            isActive: pathname.startsWith(`/analytics/ai-wrong-information/ai-equipment-tracking`),
            permission: hasPermission(PermissionEnum.AI_WRONG_INFORMATION_READ),
        },
    ].filter((i) => i.permission);

    return (
        <PageTemplate>
            <PageHeading>AI Wrong Information</PageHeading>

            {/* Mobile scroll wrapper */}
            <div className="mt-4 -mx-3 sm:mx-0">
                <div className="overflow-x-auto no-scrollbar px-3 sm:px-0">
                    <NavPills
                        className="min-w-max sm:min-w-0"
                        items={navItems.map((item) => ({
                            content: <Link to={item.href}>{item.content}</Link>,
                            isActive: item.isActive,
                            onClick: () => navigate(item.href),
                        }))}
                    />
                </div>
            </div>

            <Outlet />
        </PageTemplate>
    );
};

export default AiWrongInformationLayout;
